var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 16L16.543 0.999995","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M1 1L16.543 16","stroke":"currentColor","key":1})]);
}

CrossInline.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
